import PropTypes from "prop-types";
import MDBox from "theme/components/MDBox";
import MDInput from "theme/components/MDInput";

function DateField({ displayName, fieldRef, options }) {
  // console.log(options);
  return (
    <MDBox>
      <MDInput
        name={fieldRef}
        id={`dff_${fieldRef}`}
        margin="dense"
        label={displayName}
        type="date"
        fullWidth
        variant="outlined"
        options={options}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </MDBox>
  );
}

// Typechecking props of the Transaction
DateField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

DateField.defaultProps = {
  options: null,
};

export default DateField;
